import * as Yup from 'yup';

export default Yup.object().shape({
  startDate: Yup.date().required(),
  endDate: Yup.date().required(),
  type: Yup.string().required(),
  callerId: Yup.string().required(),
});
